import { HttpClient } from 'core/common/services';
import { getNameFromEmail } from 'core/common/utils/getNameFromEmail';
import { SupportFormSubmission, SupportFormSubmissionResult } from '../entities';
import { SupportFormServiceInterface } from '../interfaces';
import { SubmitSupportFormResponseDto } from './dto';

const SUBMIT_FIELDS = {
  formId: 'formId',
  subject: 'subject',
  requesterName: 'requesterName',
  requesterEmail: 'requesterEmail',
  description: 'description',
  customFields: 'customFields',
  attachments: 'attachments',
} as const;

export class SupportFormService implements SupportFormServiceInterface {
  constructor(private readonly httpClient: HttpClient) {}

  async submitSupportForm(submission: SupportFormSubmission): Promise<SupportFormSubmissionResult> {
    const formData = new FormData();

    formData.append(SUBMIT_FIELDS.formId, String(submission.formId));
    formData.append(SUBMIT_FIELDS.subject, submission.subject);
    formData.append(SUBMIT_FIELDS.requesterName, getNameFromEmail(submission.email));
    formData.append(SUBMIT_FIELDS.requesterEmail, submission.email);
    formData.append(SUBMIT_FIELDS.description, submission.description);
    formData.append(SUBMIT_FIELDS.customFields, JSON.stringify(submission.customFields));

    submission.files.forEach((file) => {
      if (file.size === 0) return;

      formData.append(SUBMIT_FIELDS.attachments, file, file.name);
    });

    const { data } = await this.httpClient.post<SubmitSupportFormResponseDto>(
      '/zendesk/support-forms/submit',
      {
        data: formData,
      },
    );

    return {
      requestId: data.requestId,
    };
  }
}
